import {ChangeDetectionStrategy, Component, inject, input, output} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';

import {OphPageHeaderComponent} from './../../shared/design/oph-page-header/oph-page-header.component';
import {RoleDialogComponent, RoleDialogData} from '../role-dialog/role-dialog.component';
import {ROLE_DIALOG_SETTINGS} from '../utils/role.constants';
import {Role} from '../../core/model/role';
import {MobileService} from 'src/app/core/page/mobile.service';

@Component({
  selector: 'roles-header',
  standalone: true,
  imports: [OphPageHeaderComponent],
  templateUrl: './roles-header.component.html',
  styleUrl: './roles-header.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RolesHeaderComponent {
  private readonly mobileService = inject(MobileService);
  private dialog = inject(MatDialog);
  allRoles = input.required<Role[]>();
  searchValueChange = output<string>();

  addRole(): void {
    this.dialog.open(RoleDialogComponent, {
      data: {role: null, roles: this.allRoles()} as RoleDialogData,
      ...ROLE_DIALOG_SETTINGS,
      autoFocus: this.mobileService.isMobilePlatform() ? false : undefined,
    });
  }

  onSearchChange(searchValue: string): void {
    this.searchValueChange.emit(searchValue);
  }
}
